import { isAuth, updateTokens } from '../utils/tokenServices.ts';
import { Outlet } from 'react-router';
import Loader from '../views/common/loader/Loader.tsx';

const AuthRoute = () => {
  const isInit = !isAuth();

  if (isInit) {
    updateTokens();
  }

  if (isInit) {
    return (
      <div data-testid="loader-container" className="framework-main-content">
        <Loader />
      </div>
    );
  }

  return <Outlet />;
};

export default AuthRoute;
